<template>
  <div class="p-4 w-full">
    <div class="flex justify-between items-center mb-4">
      <div class="text-lg font-semibold text-gray-900">
        {{ format(range[0]) }} - {{ formatLabel(range[1]) }}
      </div>
    </div>
    <Slider
      :value="range"
      :show-tooltip="'drag'"
      :max="upperLimit"
      :step="5"
      :format="formatLabel"
      class="size-slider z-0"
      @change="onChange"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue"
import { clientOnly } from 'vike-vue/clientOnly'
import { useAreaUnits } from '../../composables/units'

const Slider = clientOnly(() => import('@vueform/slider'))

const upperLimit = ref(200)

const { format } = useAreaUnits();

function formatLabel(value) {
  if (typeof value != 'number') return value
  let label = format.value(value)
  if (value >= upperLimit.value) label += '+'
  return label
}

function onChange([min, max]) {
  emit('update:value', { min, max: max >= upperLimit.value ? undefined : max })
}

const props = defineProps<{
  value: { min: number, max: number | undefined }
}>()
const emit = defineEmits(['update:value'])

const range = computed(() => {
  return [props.value.min, props.value.max ?? upperLimit.value]
})
</script>

<style src="@vueform/slider/themes/default.css"></style>
<style>
.size-slider {
  --slider-connect-bg: #1e3a5f;
  --slider-tooltip-bg: #1e3a5f;
  --slider-handle-ring-color: #1e3a5f30;
}
</style>
